export function truncateNumber(numberToTruncate, maxSize){
  if(numberToTruncate.length > maxSize)
    return numberToTruncate.slice(0, maxSize);
  else
    return numberToTruncate;
}